/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManagerInfoPhoto
 */
export interface ManagerInfoPhoto {
    /**
     * The photo url of the manager
     * @type {string}
     * @memberof ManagerInfoPhoto
     */
    url?: string;
}

/**
 * Check if a given object implements the ManagerInfoPhoto interface.
 */
export function instanceOfManagerInfoPhoto(value: object): value is ManagerInfoPhoto {
    return true;
}

export function ManagerInfoPhotoFromJSON(json: any): ManagerInfoPhoto {
    return ManagerInfoPhotoFromJSONTyped(json, false);
}

export function ManagerInfoPhotoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagerInfoPhoto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function ManagerInfoPhotoToJSON(value?: ManagerInfoPhoto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'url': value['url'],
    };
}

